import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../lib/theme';
import { useAuth } from '../lib/auth';

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { mode, toggle } = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  return (
    <header
      role="banner"
      className={[
        'fixed top-0 inset-x-0 z-50 transition-all duration-300',
        scrolled
          ? 'backdrop-blur-xl backdrop-saturate-150 bg-white/70 dark:bg-surface-950/70 border-b border-surface-200/60 dark:border-white/10 shadow-[0_2px_24px_rgba(15,23,42,0.04)]'
          : 'bg-transparent',
      ].join(' ')}
    >
      <nav
        aria-label="주요 내비게이션"
        className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between"
      >
        <Link to="/" className="flex items-center gap-2 font-display font-bold text-lg">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-brand-600 text-white">
            <i className="fa-solid fa-cube" aria-hidden="true" />
          </span>
          <span>빌드업</span>
        </Link>

        <ul className="hidden md:flex items-center gap-1 text-sm">
          <li><Link to="/features" className="px-3 min-h-11 inline-flex items-center rounded-lg hover:text-brand-600 hover:bg-white/40 dark:hover:bg-white/[0.04]">기능</Link></li>
          <li><Link to="/pricing" className="px-3 min-h-11 inline-flex items-center rounded-lg hover:text-brand-600 hover:bg-white/40 dark:hover:bg-white/[0.04]">요금</Link></li>
          <li><Link to="/help" className="px-3 min-h-11 inline-flex items-center rounded-lg hover:text-brand-600 hover:bg-white/40 dark:hover:bg-white/[0.04]">도움말</Link></li>
          <li><Link to="/company" className="px-3 min-h-11 inline-flex items-center rounded-lg hover:text-brand-600 hover:bg-white/40 dark:hover:bg-white/[0.04]">회사 소개</Link></li>
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <button
            type="button"
            onClick={toggle}
            aria-label={mode === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환'}
            className="h-10 w-10 grid place-items-center rounded-xl border border-surface-200 dark:border-white/10 hover:bg-white/40 dark:hover:bg-white/[0.04]"
          >
            <i className={mode === 'dark' ? 'fa-solid fa-sun' : 'fa-solid fa-moon'} aria-hidden="true" />
          </button>
          {user ? (
            <Link to="/app" className="btn btn-primary">
              <i className="fa-solid fa-gauge-high" aria-hidden="true" />
              <span>대시보드</span>
            </Link>
          ) : (
            <>
              <Link to="/login?mode=login" className="btn btn-ghost">로그인</Link>
              <Link to="/login" className="btn btn-primary">
                <span>14일 무료 시작</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </>
          )}
        </div>

        <button
          type="button"
          className="md:hidden h-11 w-11 grid place-items-center rounded-xl border border-surface-200 dark:border-white/10"
          aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <i className={menuOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'} aria-hidden="true" />
        </button>
      </nav>

      {/* 모바일 풀스크린 오버레이 메뉴 */}
      <div
        id="mobile-menu"
        role="dialog"
        aria-modal="true"
        aria-hidden={!menuOpen}
        className={[
          'fixed inset-0 md:hidden bg-white/95 dark:bg-surface-950/95 backdrop-blur-xl transition-opacity duration-300',
          menuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none',
        ].join(' ')}
      >
        <div className="px-6 pt-24 pb-12 h-full flex flex-col gap-6 text-2xl font-display">
          <Link to="/features" onClick={() => setMenuOpen(false)}>기능</Link>
          <Link to="/pricing" onClick={() => setMenuOpen(false)}>요금</Link>
          <Link to="/help" onClick={() => setMenuOpen(false)}>도움말</Link>
          <Link to="/company" onClick={() => setMenuOpen(false)}>회사 소개</Link>
          <div className="mt-auto flex gap-3">
            <Link to="/login?mode=login" className="btn btn-ghost flex-1" onClick={() => setMenuOpen(false)}>로그인</Link>
            <Link to="/login" className="btn btn-primary flex-1" onClick={() => setMenuOpen(false)}>
              무료 시작
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
